import { BoardViewType } from "app/types";
import React from "react";
import ColumnTaskCreate from "./ColumnTaskCreate";
import { TicketGroup } from "../../containers/Tickets/types";

interface AddTicketProps {
  readonly type: BoardViewType;
  readonly group: TicketGroup;
}
const Index: React.FC<AddTicketProps> = ({ type, group }) => {
  return (
    <div>
      {type === BoardViewType.KANBAN ? <ColumnTaskCreate group={group} /> : ""}
    </div>
  );
};

export default Index;
